// Protected route component with Ory support
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@hooks';
import { ROUTES } from '@constants';

export const ProtectedRoute = () => {
  const { isAuthenticated, isLoading } = useAuth();

  // Development bypass - skip authentication in development mode
  const isDevelopment = import.meta.env.VITE_ENV === 'development';
  const bypassAuth = isDevelopment && import.meta.env.VITE_BYPASS_AUTH !== 'false';

  if (bypassAuth) {
    console.log('⚠️ Development mode: Bypassing authentication');
    return <Outlet />;
  }

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-sf-blue"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  return isAuthenticated ? <Outlet /> : <Navigate to={ROUTES.LOGIN} replace />;
};
